// Configuración del cliente
export const config = {
  // URL base de la API
  apiBaseUrl: process.env.REACT_APP_API_URL || '',
  
  // Configuración de la aplicación
  appName: 'CiviTránsito',
  appVersion: '1.0.0',
  
  // Configuración de mapas
  mapboxToken: 'pk.eyJ1IjoiY2l2aXRyYW5zaXRvIiwiYSI6ImNsc2V4Z2V4Z2V4Z2V4In0.example', // Token de ejemplo
  
  // Configuración de OCR
  ocr: {
    enabled: true,
    maxFileSize: 10 * 1024 * 1024, // 10MB
    allowedTypes: ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf']
  },
  
  // Configuración de notificaciones
  notifications: {
    duration: 4000,
    position: 'top-right'
  }
};

export default config;
